import { RestaurantDetailContact } from '@/features/restaurants/restaurant-detail/restaurant-detail-contact/restaurant-detail-contact'
import { useRestaurantDetailContext } from '@/features/restaurants/restaurant-detail/restaurant-detail-context'
import { RestaurantDetailSection } from '@/features/restaurants/restaurant-detail/restaurant-detail-section'
import { RestaurantDetailSectionId } from '@/features/restaurants/restaurant-detail/utils/restaurant-detail-helpers'

export const RestaurantDetailContactSection = () => {
    const { restaurant } = useRestaurantDetailContext()

    if (!restaurant?.phone) return null

    return (
        <RestaurantDetailSection
            id={RestaurantDetailSectionId.CONTACT}
            title="restaurants.detail.contact.title"
            description="restaurants.detail.contact.description"
            className="mb-14"
        >
            <RestaurantDetailContact />
        </RestaurantDetailSection>
    )
}
